module.exports = __webpack_public_path__ + "static/media/closeDark.dcd4fa9f.svg";